var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab_container"},[_c('div',{class:_vm.renderButtonStyling,on:{"click":function($event){return _vm.switchStyling()}}},[_c('span',{staticClass:"placeholder-text"},[_vm._v(" "+_vm._s(_vm.text))]),_c('div',{staticClass:"bottom-arrow"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }